import React, {Fragment, useEffect, useRef, useState} from 'react';
import makeStyles from "@mui/styles/makeStyles";
import {useTranslation} from "react-i18next";
import API from "../../app/api";
import parse from "autosuggest-highlight/parse";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import {useDebounce} from "use-debounce";
import _, {isEmpty} from "lodash";
import {FormLabel, Grid, IconButton, InputLabel} from '@mui/material';
import AgyleDictionaryField from "../../components/ui/selector/agyleDictionaryField";
import AgyleTextField from "../../components/ui/fields/agyleTextField";
import clsx from 'clsx';
import {useSelector} from 'react-redux';
import {agylePref} from '../../store/reducers/preferences';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {Portal} from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const useStyles = makeStyles((theme) => ({
    root: {
        //  backgroundColor: theme.palette.mode === "light" ? "#ffffff" : "#333333",
    //    boxShadow: `0px 0px ${theme.palette.mode === 'light' ? 6 : 0}px 0px rgba(0, 0, 0, 0.25)`,
        borderRadius:5,
        width: "100%"
    //    padding: 8,
    },
    avatarCustom: {
        width: "auto !important",
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 15,
        backgroundColor: theme.palette.background.paper,
        color: "#fff",
    },
    snomedCode: {
        display: "inline",
        fontSize: "80%",
        fontWeight: "bold",
        backgroundColor: theme.palette.background.default,
        padding: "3px 8px",
        marginRight: 10,
        borderRadius: 4,
    },
    snomedDescription: {
        display: "inline",
    },
    label: {
        color: theme.palette.mode === 'light' ? '#252525' : '#FFFFFF',
        fontWeight: 400,
        fontSize: 12,
        display: "inline-flex",
        alignItems: "center",
        fontFamily: "Inter",
        width: "100%",
        justifyContent: "space-between"
    },
    divRowAdd: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        justifyContent: 'space-between',
        alignItems: "center",
        paddingLeft: 0,
       // border: "1px solid " + (theme.palette.mode === "light"? "#acb1b5": "#636466"),
        borderRadius: 8,
        height: 36,
     //   maxWidth: "180px",
      //  width: "180px",
        padding: '0px 0px',
        gap: 10,
    },
    divRow: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        justifyContent: 'space-between',
        alignItems: "center",
        paddingLeft: 10,
        border: "1px solid " + (theme.palette.mode === "light"? "#acb1b5": "#636466"),
        borderRadius: 8,
        height: 36,
        padding: '0px 3px',
        gap: 10,
    },
    numberTag: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: 10, height: 20,
        minWidth: 20,
        fontSize: 12,
        background: "#2280f7",
        color: "white",
        borderRadius: 6
    },
    inputRoot: {
        minWidth: '100%'
    },
    textBackground: {
        background: "red"
    },
    menuItem: {
        wordWrap: "wrap",
        padding: 0,
        fontSize: 12,
        whiteSpace: 'normal'

    },
    dropdownStyle: {
        background: theme.palette.mode === "light" ? "#ffffff" : "#4a4b4c"
    }
}));

function AutocompleteDropdownDictionary(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const agylePreference = useSelector(agylePref);

    const controller = new AbortController();

    const [autocompleteOpen, setAutocompleteOpen] = React.useState(false);
    const [autocompleteOptions, setAutocompleteOptions] = React.useState([]);
    const [autocompleteInputValue, setAutocompleteInputValue] = React.useState('');
    const [autocompleteLoading, setAutocompleteLoading] = React.useState(false);

    const [autocompleteInputValueDebounced] = useDebounce(autocompleteInputValue, 250);
    const [value, setValue] = useState(props.multiple ? [] : null);

    const renderText = props.renderText;
    const [focus, setFocus] = useState();

    useEffect(() => {
        let isMounted = true;

        if (props.showAll || (autocompleteInputValueDebounced && !_.isEmpty(autocompleteInputValueDebounced))) {
            let filter = "";

            if (props.dontTrimSearch) {
                filter = getFilter(autocompleteInputValueDebounced, filter, escapeRegExp);
            } else {
                for (let term of autocompleteInputValueDebounced.split(" ")) {
                    filter = getFilter(term, filter, escapeRegExp);
                }
            }
            if(props.noRegex) {
                filter = autocompleteInputValueDebounced
            }
            setAutocompleteLoading(true);

            if (_.isNil(props.dataType) || props.dataType === "API") {

                if (!props.cliniciansWithNurses) {
                    API.getDictByURL(props.dictionaryURL(filter), controller.signal).then(dictData => {
                        if (!isMounted) return;

                        if (dictData?.__data && !_.isEmpty(dictData.__data)) {
                            let data = dictData.__data;
                            if (props.filterByIds) {
                                if (!_.isEmpty(props.filterIds)) {
                                    data = data.filter(element => {
                                        return props.filterIds.some((filter) => {
                                            return filter === element.__id;
                                        });
                                    });
                                } else {
                                    data = [];
                                }
                            }
                            setAutocompleteOptions(data);
                        } else {
                            setAutocompleteOptions([]);
                        }
                        setAutocompleteLoading(false);
                    }).catch(function (error) {
                        console.error("Autocomplete dictionaries error", error);
                    });
                } else {
                    getCliniciansWithNurses(filter);
                    setAutocompleteLoading(false);
                }
            } else if (props.dataType === 'admission') {
                API.getDictByURL(props.dictionaryURL(filter), controller.signal).then(dictData => {
                    if (!isMounted) return;

                    if (dictData) {
                        let data = dictData;
                        if (props.filterByIds) {
                            if (!_.isEmpty(props.filterIds)) {
                                data = data.filter(element => {
                                    return props.filterIds.some((filter) => {
                                        return filter === element.__id;
                                    });
                                });
                            } else {
                                data = [];
                            }
                        }
                        setAutocompleteOptions(data);
                    } else {
                        setAutocompleteOptions([]);
                    }
                    setAutocompleteLoading(false);
                }).catch(function (error) {
                    console.error("Autocomplete dictionaries error", error);
                });
            } else {
                setAutocompleteLoading(false);
                setAutocompleteOptions(props.options || []);
            }
        }
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autocompleteInputValueDebounced, props.filterCode, props.filterIds, props.dataType]);

    useEffect(() => {
        if (props.multiple && _.isNull(props.value)) {
            setValue([]);
        } else {
            setValue(props.value || null);
        }
    }, [props.value]);

    function getCliniciansWithNurses(filter) {
        Promise.all([
                getClinician(filter, "Clinicians"),
                getClinician(filter, "Nurses")
            ])
            .then(([clinicians, nurses]) => {
                const combinedOptions = [];

                if (!_.isEmpty(clinicians)) {
                    combinedOptions.push(...clinicians);
                }

                if (!_.isEmpty(nurses)) {
                    combinedOptions.push(...nurses);
                }
                setAutocompleteOptions(combinedOptions);
            })
            .catch(error => {
                console.error("Autocomplete dictionaries error", error);
            });
    }

    async function getClinician(filter, clinicianType) {
        let medicalStaff = [];
        try {
            const dictData = await API.getDictByURL(props.getClinicianURL(clinicianType, filter), controller.signal);
            if (dictData?.__data && !_.isEmpty(dictData.__data)) {
                let data = dictData.__data;

                if (props.filterByIds) {
                    if (!_.isEmpty(props.filterIds)) {
                        data = data.filter(element => {
                            return props.filterIds.some(filter => {
                                return filter === element.__id;
                            });
                        });
                    } else {
                        data = [];
                    }
                }
                medicalStaff = data.map(clinician => ({
                    ...clinician,
                    group: clinicianType,
                }));
            }
        } catch (error) {
            console.error(error);
        }
        return medicalStaff;
    }

    // Get input search
    function getFilter(input, filter) {
        if (!_.isEmpty(input)) {
            if (!_.isEmpty(filter)) filter += " AND ";
            if (props.searchColumnName) {
                filter += `${props.searchColumnName} regex '.*` + escapeRegExp(input) + `.*'`;
            }
            if (props.multiSearchColumnName) {
                for (let i = 0; i < props.multiSearchColumnName?.length; i++) {
                    if (i > 0) {
                        filter += " or ";
                    }
                    filter += `${props.multiSearchColumnName[i]} regex '.*` + escapeRegExp(input) + `.*'`;
                }
            }
        }
        return filter;
    }

    const renderOptionLine = (createParts, option, classes, inp) => {
        return  <MenuItem {...inp} className={classes.menuItem} style={{

        }}>
            <Checkbox
                checked={inp['aria-selected']}
                disableRipple
            />
            <div> {option[props.path]} </div>
        </MenuItem>
    };

    const createParts = optionValue => {
        let matches = [];
        if (optionValue && autocompleteInputValueDebounced && !_.isEmpty(autocompleteInputValueDebounced)) {
            let idx = optionValue.toLowerCase().indexOf(autocompleteInputValueDebounced.toLowerCase());
            while (idx >= 0) {
                matches.push([idx, idx + autocompleteInputValueDebounced.length]);
                idx = optionValue.toLowerCase().indexOf(autocompleteInputValueDebounced.toLowerCase(), idx + autocompleteInputValueDebounced.length);
            }
        }
        return parse(optionValue, matches);
    };

    const renderLocalOption = (option, inp) => {
        if (props.renderLocalOption) {
            return props.renderLocalOption(createParts, option, classes, inp);
        } else {
            return renderOptionLine(createParts, option, classes, inp);
        }
    };

    const handleChange = (event, newValues, reason) => {
        if (props.onChangeAdvanced) {
            props.onChangeAdvanced(newValues, reason);
        } else {
            props.onChange(newValues);
        }
    };


    const openAutocomplete = () => {
        if (!autocompleteOpen) {
            setAutocompleteOpen(true);
            setTimeout(() => {
                focus?.focus()
            }, 10);
        }
    };

    const handleLeave = () => {
       // if (autocompleteOpen) setAutocompleteOpen(false);
    }

    const handleAutocompleteState = (val) => {
        setAutocompleteOpen(val);
    };

    const userNameRef = useRef(null);

    const getOptions = () => {
        if(props.value.length === 0)
            return autocompleteOptions;

        if(props.onlyAddButton)
            return _.filter(autocompleteOptions, (el) => !props.value.some((v) => v[props.pathToEqualValue] === el[props.pathToEqualValue]))
        else
            return _.uniqBy(props.value?.concat(autocompleteOptions), (el) => el[props.pathToEqualValue])
    }

    return (
        <div className={clsx(classes.root)} onPointerLeave={handleLeave}>
            {!props.open && <div style={{position: "relative", minHeight: 36}} ref={userNameRef}>

                {props.onlyAddButton && !autocompleteOpen &&
                <div className={classes.divRowAdd}
                     onClick={openAutocomplete}
                >
                    {props.addButtonRender}

                    {!props.addButtonRender && <div>
                        <IconButton
                            disableRipple
                            disabled={props.disabled}
                            color="primary"
                        >
                            <AddCircleOutlineIcon/>
                        </IconButton>
                    </div>
                    }
                </div>
                }
                {(props.inputWithTag || !props.onlyAddButton) &&
                <div className={classes.divRow} style={{borderColor: props.value.length > 0? "#2180F7": "", background: props.background}} onClick={openAutocomplete}>
                    <FormLabel className={classes.label}>
                        <div> {props.label} </div>

                    </FormLabel>

                    {props.value.length > 0 &&
                        <div className={classes.numberTag}>
                            {props.value.length}
                        </div>
                    }

                    <div>
                        {props.endAdornmentAddons && props.endAdornmentAddons()}

                        {props.value.length === 0 && <IconButton
                            disableRipple
                            disabled={props.disabled}
                            style={{padding: 0}}
                        >
                            <ArrowDropDownIcon style={{rotate: autocompleteOpen ? "180deg" : ""}}/>
                        </IconButton>
                        }
                    </div>
                </div>
                }

            </div>

            }

            {autocompleteOpen &&
            <Portal container={userNameRef.current}>
                <div  style={{position: "absolute", width: "100%", minWidth: "190px", zIndex: 1000}}>
                    <AgyleDictionaryField
                        focusInput={setFocus}
                        multiple={props.multiple}
                        disableCloseOnSelect={!props.closeOnSelect}
                        size={props.size}
                        label={''}
                        dropdownStyle={classes.dropdownStyle}
                        color={props.color}
                        className={props.className ? props.className : null}
                        open={autocompleteOpen}
                        openOnFocus={true}
                        onOpen={handleAutocompleteState.bind(this, true)}
                        onClose={handleAutocompleteState.bind(this, false)}
                        onBlur={handleAutocompleteState.bind(this, false)}
                        limitTags={props.limitTags}
                        bigLabel={props.bigLabel}
                        disabled={props.disabled || props.loadingState}
                        isOptionEqualToValue={(option, value) => props.isOptionEqualToValue
                            ? props.isOptionEqualToValue(option, value)
                            : option?.snomedDescription === value?.snomedDescription}
                        getOptionLabel={(option) => props.getOptionLabel ? props.getOptionLabel(option) : option.snomedDescription}
                        placeholder={props.placeholder}
                        options={getOptions()}
                        loading={autocompleteLoading}
                        filterOptions={(x) => x}
                        groupBy={props.groupBy}
                        noOptionsText={!isEmpty(autocompleteInputValueDebounced) ? t("Nothing found") : t("Please enter at least one letter")}
                        loadingText={t("Loading data ...")}
                        onInputChange={(event, newInputValue) => setAutocompleteInputValue(newInputValue)}
                        value={value}
                        onChange={handleChange}
                        getOptionDisabled={props.getOptionDisabled ? props.getOptionDisabled : () => {
                            return false;
                        }}
                        required={props.required}
                        disableClearable
                        paperBackground={props.paperBackground}
                        withBackground={props.withBackground}
                        noBorder={props.noBorder}
                        error={props.error}
                        popupIcon={""}
                        endAdornment={props.endAdornment}
                        clearIcon={<div/>}
                        endAdornmentAddons={props.endAdornmentAddons}
                        extended={true}
                        renderInput={(params) => (
                            <div style={{position: 'relative'}}>
                                <AgyleTextField
                                 //   {...params}
                                    error={props.error}
                                    size={props.size}
                                    label={props.label}
                                    color={props.color}
                                    textFieldClass={clsx( classes.textBackground, props.inputClass)}
                                    variant="outlined"
                                    InputProps={{
                                        ...props.inputProps,
                                        ...params.InputProps,
                                        startAdornment: props.startTextBoxAdornment ? props.startTextBoxAdornment() : params.InputProps.startAdornment,
                                        endAdornment: (
                                            <Fragment>
                                                {/*{props.endAdornmentAddons && props.endAdornmentAddons()}*/}
                                                {autocompleteLoading ? <CircularProgress color="inherit" size={20}/> : null}
                                                {/*{params.InputProps.endAdornment}*/}
                                            </Fragment>
                                        ),
                                    }}
                                />

                                {props.loadingState &&
                                <CircularProgress style={{position: 'absolute', left: '50%', top: '15%'}}/>
                                }
                            </div>
                        )}
                        startTextBoxAdornment={props.startTextBoxAdornment}
                        renderTags={(tagValue, getTagProps) => ""}
                        renderOption={(props, option, {selected}) => renderLocalOption(option, props)}
                    />
                </div>


            </Portal>
            }
        </div>

    );
};

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\\\$&').replace(/[']/g, "\\'"); // $& means the whole matched string
}

export {
    AutocompleteDropdownDictionary,
    escapeRegExp
};
